import { IAbsence } from '../interfaces/Types';

export const getAbsencesByTimestampRange = (absences: IAbsence[], from: number, to: number): IAbsence[] => {
  return absences.filter((item) => item.timestamp >= from && item.timestamp <= to);
};

export const getAbsencesByTimestamp = (absences: IAbsence[], timestamp: number): IAbsence | undefined => {
  return absences.find((item) => item.timestamp === timestamp);
};

export const getHolidaysByTimestampRange = (absences: IAbsence[], from: number, to: number): IAbsence[] => {
  return absences.filter((item) => item.timestamp >= from && item.timestamp <= to && ['Urlaub', 'Schließtag'].includes(item.absencetype));
};

export const getSickDaysByTimestampRange = (absences: IAbsence[], from: number, to: number): IAbsence[] => {
  return absences.filter((item) => item.timestamp >= from && item.timestamp <= to && item.absencetype === 'Krankheit');
};

export default { getAbsencesByTimestamp, getAbsencesByTimestampRange, getHolidaysByTimestampRange, getSickDaysByTimestampRange };
